var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion",style:({ border: `1px solid ${_vm.$themeTokens.fineLine}` })},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"header",style:({
      borderColor: _vm.$themeTokens.fineLine,
      backgroundColor: _vm.$themePalette.grey.v_100,
      ..._vm.headerAppearanceOverrides,
    })},[_vm._t("header",null,{"canExpandAll":_vm.canExpandAll,"expandAll":_vm.expandAll,"canCollapseAll":_vm.canCollapseAll,"collapseAll":_vm.collapseAll})],2):_vm._e(),_c(_vm.listWrapperTag,{tag:"component",staticClass:"accordion-list-wrapper"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }